<template>
  <div class="banner">
    <img :src="img1" style="display: none" alt="" />
    <div class="container">
      <div class="banner-inner row">
        <!-- Back Button -->
        <div class="back-btn" />
        <!-- Back Button -->
        <!-- User Detail -->
        <div class="user row">
          <div class="user-img">
            <img
              v-if="blogger.user && blogger.user.imgURL"
              :src="blogger.user.imgURL"
              :alt="blogger.user.firstname"
            />
          </div>
          <div v-if="blogger.user" class="name">
            {{ blogger.user.firstname }} {{ blogger.user.lastname }}
            <social-share
              v-if="blogger.profile && blogger.profile.profileName"
              path="blog/crew/"
              :slug="blogger.profile.profileName"
            />
          </div>
          <div class="title">
            {{ blogger.title }}
          </div>
          <h5
            v-if="blogger.profile && blogger.profile.profileName"
            class="email"
          >
            @{{ blogger.profile.profileName }}
          </h5>
          <div v-if="blogger.profile && blogger.profile.tags" class="fields">
            <div
              class="field"
              v-for="(tag, i) in blogger.profile.tags"
              :key="i"
            >
              {{ tag.text }}
            </div>
          </div>
          <!-- div class="title">
            10 Thank Yous  12 Followers 20 Blogs
          </div -->
          <p v-if="blogger.profile && blogger.profile.bio" class="detail">
            {{ blogger.profile.bio.substr(0, 200) }}
            {{ blogger.profile.bio.length > 200 ? "..." : "" }}
          </p>
        </div>
        <!-- User Detail -->
        <div class="video">
          <button
            v-if="blogger.profile && blogger.profile.videoURL"
            class="video-btn btn-light "
          >
            <span>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.0834 6.41666L14.6667 11L21.0834 15.5833V6.41666Z"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <!-- stroke="#557EFB" -->
                <path
                  d="M12.8334 4.58333H2.75008C1.73756 4.58333 0.916748 5.40414 0.916748 6.41666V15.5833C0.916748 16.5959 1.73756 17.4167 2.75008 17.4167H12.8334C13.8459 17.4167 14.6667 16.5959 14.6667 15.5833V6.41666C14.6667 5.40414 13.8459 4.58333 12.8334 4.58333Z"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <!-- stroke="#557EFB" -->
              </svg>
            </span>
            Video
          </button>
          <!-- <p class="address">Los Angeles, CA</p> -->
          <p
            v-if="
              blogger.profile &&
                blogger.profile.social &&
                blogger.profile.social.businessURL
            "
            class="address"
          >
            <a :href="`https://${blogger.profile.social.businessURL}`">{{
              blogger.profile.social.businessURL
            }}</a>
          </p>
        </div>
      </div>
    </div>
    <div
      class="top-img"
      v-bind:style="{ 'background-image': 'url(' + img + ')' }"
    ></div>
  </div>
</template>

<script>
import SocialShare from "@/components/common/socialShare";
export default {
  components: {
    SocialShare
  },
  data() {
    return {
      ratings: [
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `,
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `,
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `,
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `,
        `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4505 5.63406L11.3543 4.90408L9.07611 0.352135C9.01388 0.227506 8.91152 0.126615 8.78506 0.0652895C8.46793 -0.0890138 8.08254 0.0395723 7.92397 0.352135L5.64581 4.90408L0.549539 5.63406C0.409035 5.65384 0.280575 5.71912 0.182222 5.81803C0.0633192 5.93848 -0.00220171 6.10053 5.64944e-05 6.26856C0.0023147 6.4366 0.0721672 6.59688 0.194265 6.71418L3.88148 10.2572L3.01036 15.2602C2.98993 15.3766 3.003 15.4963 3.04808 15.6057C3.09316 15.7151 3.16845 15.8099 3.26541 15.8793C3.36237 15.9488 3.47713 15.99 3.59666 15.9984C3.7162 16.0068 3.83573 15.982 3.9417 15.9269L8.50004 13.5648L13.0584 15.9269C13.1828 15.9922 13.3273 16.0139 13.4658 15.9902C13.8151 15.9308 14.0499 15.6044 13.9897 15.2602L13.1186 10.2572L16.8058 6.71418C16.9062 6.61724 16.9724 6.49064 16.9925 6.35216C17.0467 6.00597 16.8018 5.68549 16.4505 5.63406Z" fill="#F8D57C"/>
        </svg>
        `
      ],
      img: require("@/assets/top-svg.png"),
      img1: require("@/assets/Vector.png")
    };
  },
  props: {
    blogger: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  /* bottom center no-repeat  */
  background-image: url("../../../../assets/Vector.png") !important;
  background-position: bottom center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  /* border-top: 1px solid #000; */
}
.banner-inner {
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;
  font-family: "Nunito", sans-serif;
  flex-wrap: wrap;
  margin-top: 25px;

  padding: 10px 30px;
  position: relative;
  padding-top: 55px;
  /* overflow: hidden; */
  flex-wrap: wrap;
  background-position: bottom center;
  background-size: contain;
  background-repeat: no-repeat;
  padding-bottom: 139px;
}
.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  box-sizing: border-box;
  color: #52595e;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  border: none;
  background: none;
}
.back-btn span {
  padding-right: 10px;
  padding-bottom: 3px;
}
.user {
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
}
.user .user-img {
  width: 116px;
  height: 116px;
  img {
    border-radius: 50%;
  }
}
.user .name {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;

  margin: 10px 0;

  color: #52595e;
}

.user .title {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  margin: 0px 0;
  color: #52595e;
}

.user .name,
.title span {
  padding-bottom: 3px;
}
.email {
  font-style: normal;
  font-weight: normal !important;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #8d99a0;
  font-family: "Nunito", sans-serif;
}
.fields {
  width: 207px;
  height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 24px;
}
.fields .field {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #8d99a0;
  margin-right: 15px;
  cursor: pointer;
}
.detail {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #52595e;
}
.fee {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 4px 0px 0px; */

  /* max-width: 331px; */
  /* width: 100%; */
  height: 32px;

  border-radius: 16px;
}
.fee span {
  /* margin-bottom: 16px; */
}
.fee p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #52595e;
}
.video {
  display: flex;
  /* justify-content: space-between; */
  /* align-items: center; */
}
.video-btn {
  transition: 0.3s linear;
  display: flex;
  align-items: center;
  box-shadow: none;
  justify-content: center;
  padding: 0 !important;
  width: 104px;
  height: 40px;
  border: 1px solid #557efb;
  box-sizing: border-box;
  border-radius: 32px;
  color: #557efb;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  background: none;
  margin-right: 15px;
  path {
    stroke: #557efb;
    transition: 0.3s linear;
  }
}
.video-btn span {
  padding-right: 10px;
}
.video-btn:hover {
  box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
  color: #fff;
  background-color: #557efb;
  path {
    stroke: #fff;
  }
}
/* .video-btn svg path {
  fill: #557efb;
}
.video-btn:hover svg path {
  fill: #fff;
} */
.address {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: right;
  color: #52595e;
  width: 122px;
  height: 44px;
  font-family: "Nunito", sans-serif;
}
.top-img {
  position: absolute;
  width: 328px;
  height: 274px;
  background-repeat: no-repeat;
  top: 0px;
  right: 0px;
  z-index: -1;
  /* background-position: bottom center; */
  background-size: contain;
  background-repeat: no-repeat;
}
@media (max-width: 1100px) {
  .banner-inner {
    justify-content: center;
    /* padding-bottom: 10px; */
  }
  .video {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
@media (max-width: 990px) {
  .back-btn {
    position: absolute;
    left: 0;
  }
}
@media (max-width: 500px) {
  .back-btn {
    position: absolute;
    left: 12px;
    top: 17px;
  }
  .banner-inner {
    padding: 10px;
  }
  .user-img {
    width: 80px;
    height: 80px;
  }
  .user {
    margin-top: 50px;
  }
}
@media (max-width: 500px) {
  .video-btn {
    width: 88px;
    height: 32px;
  }
  .fee {
    flex-direction: column;
    margin-bottom: 10px;
  }
  .video {
    flex-direction: column;

    margin-top: 40px;
  }
  .address {
    margin-top: 10px;
    text-align: left;
  }
}
</style>
